'use strict';

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.array.flat-map");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function extractMinWidths(breakpoints) {
  return _lodash2.default.flatMap(breakpoints, function (breakpoints) {
    if (_lodash2.default.isString(breakpoints)) {
      breakpoints = {
        min: breakpoints
      };
    }

    if (!_lodash2.default.isArray(breakpoints)) {
      breakpoints = [breakpoints];
    }

    return (0, _lodash2.default)(breakpoints).filter(function (breakpoint) {
      return _lodash2.default.has(breakpoint, 'min') || _lodash2.default.has(breakpoint, 'min-width');
    }).map(function (breakpoint) {
      return _lodash2.default.get(breakpoint, 'min-width', breakpoint.min);
    }).value();
  });
}
/* eslint-disable no-shadow */


module.exports = function (options) {
  return function (_ref) {
    var addComponents = _ref.addComponents,
        config = _ref.config;

    var screens = _lodash2.default.get(options, 'screens', config('screens'));

    var minWidths = extractMinWidths(screens);

    var atRules = _lodash2.default.map(minWidths, function (minWidth) {
      var _ref2;

      return _ref2 = {}, _ref2["@media (min-width: " + minWidth + ")"] = {
        '.container': {
          'max-width': minWidth
        }
      }, _ref2;
    });

    addComponents([{
      '.container': Object.assign({
        width: '100%'
      }, _lodash2.default.get(options, 'center', false) ? {
        marginRight: 'auto',
        marginLeft: 'auto'
      } : {}, _lodash2.default.has(options, 'padding') ? {
        paddingRight: options.padding,
        paddingLeft: options.padding
      } : {})
    }].concat(_toConsumableArray(atRules)));
  };
};